<script>
    import slider from 'shared/Components/slider.vue';
    import errorList from "shared/Components/errorList.vue";
    import { get, postForm, getIbeHost, getCDNHost } from 'shared/Utilities/fetchUtilities';
    import moment from "moment";
    import { getMember } from "shared/member";
    import f9button from "inputs/f9button.vue";
    import passwordRequirements from "forms/passwordRequirements.vue";
    import { login, dispatchLoginEvent } from "shared/login";
    import signupFields from "forms/signupFields.vue";
    import frontierMilesInfo from "forms/frontierMilesInfo.vue";
    import ddInfo from "forms/ddInfo.vue";
    import loginComponent from "forms/login.vue";
    import { getDiscountDenPrice } from 'shared/resource';
    import {
        continueToPassengerEditFromLoginOrDDSignup,
        isThisFlightRoundTripAndOneFareIsDiscountDenAndAnotherOneIsGoWild
    } from "shared/Utilities/flightSelectUtilites";

    export default {
        props: {
            "reloadOnLogin": Boolean,
            "showSuccess": {
                type: Boolean,
                default: true
            },
            "inSlider": {
                type: Boolean,
                default: true
            },
            "profileUrl": {
                type: String,
                default: '/FrontierMiles/Profile'
            },
            "validationScope": {
                type: String,
                default: "signup"
            },
            "inPathDD": {
                type: Boolean,
                default: false
            },
            "discountDenInformation": { }
        },
        components: {
            slider,
            errorList,
            f9button,
            passwordRequirements,
            signupFields,
            frontierMilesInfo,
            ddInfo,
            login: loginComponent
        },
        data() {
            return {
                customer: {
                    email: "",
                    confirmEmail: "",
                    password: "",
                    confirmPassword: "",
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    suffix: "",
                    gender: "",
                    birthDate: null,
                    country: "",
                    address: "",
                    address2: "",
                    zipCode: "",
                    city: "",
                    state: "",
                    phone: ""
                },
                submitting: false,
                imageRelativePath: "/Content/responsive/images/",
                isSuccess: false,
                changed: false,
                host:"",
                cdnHost:"//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net",
                flightSelectForm: HTMLElement,
                formId: this.inPathDD ? "dd-signup-form" : "er-signup-form",
                formTitle: "SIGN UP NOW!",
                ddCost: "$XX.XX",
                discountAmount: "",
                enrollmentFeeAmount:"",
                discountedEnrollmentFeeAmount: "",
                signupFeeAmount: "",
                totalAmount: "",
                barclaysFrontierMilesSignupLink: "",
            }
        },
        computed: {
            sliderModalOpacity() {
                return this.inSlider ? 0 : .5;
            }
        },
        created(){
            this.getDiscountDenInfo();
            this.getBarclaysSignupLink();
        },
        mounted() {
            if(this.inPathDD) {
                getDiscountDenPrice()
                    .then(x => this.ddCost = "$" + x);
            }

            this.$nextTick(() => this.host = getIbeHost());
            this.$nextTick(() => this.cdnHost = getCDNHost());  
        },
        methods: {
            getDiscountDenInfo() {
                get(getIbeHost() + "/F9Loyalty/DiscountDenDetails?isSessionless=false")
                .then(x => x.json())
                .then(obj => {
                    this.discountAmount = obj.discountAmount;
                    this.enrollmentFeeAmount = obj.enrollmentFeeAmount;
                    this.discountedEnrollmentFeeAmount = obj.discountedEnrollmentFeeAmount;
                    this.signupFeeAmount = obj.signupFeeAmount;
                    this.totalAmount = obj.totalAmount;
                });
            },
            getBarclaysSignupLink() {
                get(getIbeHost() + "/F9Loyalty/BarclaysFrontierMilesSignupLink")
                .then(x => x.json())
                .then(link => {
                    this.barclaysFrontierMilesSignupLink = link;
                });
            },
            submit() {
                this.submitting = true;
                this.validate(this.validationScope).then(result => {
                    let isValid = this.$refs.fields ? this.$refs.fields.validateSignupFieldsConsistency() : true;

                    if (!result || !isValid) {
                        this.submitting = false;
                    } else {
                        var formObject = {
                            "frontierRegisterMember.Member.PersonalEmailAddress.EmailAddress": this.customer.email,
                            "frontierRegisterMember.Member.Username": this.customer.email,
                            "frontierRegisterMember.erSignupConfirmEmailAddr":this.customer.confirmEmail,
                            "frontierRegisterMember.Member.Password": this.customer.password,
                            "frontierRegisterMember.Member.NewPasswordConfirmation": this.customer.confirmPassword,
                            "frontierRegisterMember.Member.Name.First": this.customer.firstName,
                            "frontierRegisterMember.Member.Name.Middle": this.customer.middleName,
                            "frontierRegisterMember.Member.Name.Last": this.customer.lastName,
                            "frontierRegisterMember.Member.Name.Suffix": this.customer.suffix,
                            "frontierRegisterMember.Member.Gender": this.customer.gender,
                            "frontierRegisterMember.Member.DateOfBirth": moment(this.customer.birthDate).format('YYYY-MM-DD'),//convert to ISO format
                            "frontierRegisterMember.Member.HomeAddress.CountryCode": this.customer.country,
                            "frontierRegisterMember.Member.HomeAddress.AddressLine1": this.customer.address,
                            "frontierRegisterMember.Member.HomeAddress.AddressLine2": this.customer.address2,
                            "frontierRegisterMember.Member.HomeAddress.PostalCode": this.customer.zipCode,
                            "frontierRegisterMember.Member.HomeAddress.City": this.customer.city,
                            "frontierRegisterMember.Member.HomeAddress.ProvinceState": this.customer.state,
                            "frontierRegisterMember.Member.MobilePhoneNumber.Number": this.customer.phone.replace(/[^0-9]+/g, '')//remove any characters and just pass raw numbers
                        };

                        if (this.inPathDD) {
                            formObject["frontierRegisterMember.DiscountDenInformation.IsDiscountDenBooking"] = this.inPathDD;
                            formObject["frontierRegisterMember.FlightSellKeys.DepartureSellKey"] = this.discountDenInformation.departKey;
                            formObject["frontierRegisterMember.DiscountDenInformation.DiscountDenDepartureSavings"] = this.discountDenInformation.departureSavings;
                            formObject["frontierRegisterMember.FlightSellKeys.ReturnSellKey"] = this.discountDenInformation.returnKey;
                            formObject["frontierRegisterMember.DiscountDenInformation.DiscountDenReturnSavings"] = this.discountDenInformation.returnSavings;
                        }

                        postForm(this.host + "/Member/FrontierMilesSignup", formObject)
                            .then(response => {
                                if (response.ok) {
                                    setTimeout(() => {
                                        login(this.customer.email, this.customer.password, this.host, !this.inPathDD)
                                            .then(result => {
                                                this.submitting = false;
                                                if (result.valid) {
                                                    this.changed = false;
                                                    this.isSuccess = !this.inPathDD;
                                                    if (this.inPathDD && this.continueToPassengerEdit()) {
                                                        // Is it a round trip and there is one GW fare?
                                                        if (isThisFlightRoundTripAndOneFareIsDiscountDenAndAnotherOneIsGoWild()) {

                                                            // Close current DD sliders
                                                            this.$parent.$emit("hide-slider");

                                                            // Set global variable to go directly to GW signup slider
                                                            window.ddOfferAccepted = true;

                                                            // Show GoWild Signup
                                                            window.flightSelectShowSignUpGoWildSlider();

                                                        } else {

                                                            this.submitFlightSelect();

                                                        }
                                                    }
                                                    else {
                                                        getMember(false, null, this.host).then(event => {
                                                            this.changed = false;
                                                            dispatchLoginEvent();
                                                            if (this.reloadOnLogin) {
                                                                window.location.reload();
                                                            }
                                                        });
                                                    }
                                                }
                                            })
                                            .catch(ex => {
                                                this.submitting = false;
                                                //console.log("signup error 3", ex);
                                            });
                                    }, 3000);
                                } else {
                                    this.submitting = false;
                                    response.text().then(responseString => {
                                        //console.log("signup error 2", responseString);
                                    });
                                }
                            })
                            .catch(ex => {
                                this.submitting = false;
                                //console.log("signup error 1", ex);
                            });
                    }
                });
            },
            viewProfile () {
                window.location.href = this.host + this.profileUrl;
            },
            submitFlightSelect() {
                this.flightSelectForm = document.getElementById("flight-select-form");
                if (this.flightSelectForm) {

                    this.flightSelectForm.submit();
                }
            },
            continueToPassengerEdit(){
                return continueToPassengerEditFromLoginOrDDSignup();
            }
        }
    }
</script>

<template>
    <div>
        <div :id="formId" class="signup-container" v-if="!isSuccess" :class="{ standalone: !inSlider }" @keyup.enter="submit">
            <frontier-miles-info v-if="!inPathDD" :cdnHost="cdnHost"></frontier-miles-info>
            <dd-info v-else :host="host" :imageRelativePath="imageRelativePath" :inSlider="inSlider" :discountAmount="this.discountAmount" :enrollmentFeeAmount="this.enrollmentFeeAmount" :signupFeeAmount="this.signupFeeAmount" :totalAmount="this.totalAmount" :discountedEnrollmentFeeAmount="this.discountedEnrollmentFeeAmount"></dd-info>

            <!-- Login Form Container -->
            <div class="login-section" v-if="inPathDD">
                <div class="login-info-header">
                    <div>Already have a&nbsp;</div>
                    <div class="Frontier">FRONTIER MILES</div>
                    <span class="sm">&#8480;</span>
                    <div>&nbsp;account?</div> 
                </div>
                <div class="login-form-section">
                    <div class="login-form-header">
                        Log In Now!
                    </div>
                    <login :inPathDD="inPathDD" @login-success="changed = false" :reload-on-login="true" :show-signup="false" :has-gray-background="false" @change="changed = true"></login>
                </div>
            </div>

            <!-- ER Signup Form Container -->
            <error-list ref="errorList" :messages="errors.items" :top-rules="['age_restriction']"></error-list>

            <div class="signup-legend text-small">
                *Required Fields
            </div>

            <div class="signup-info-header">
                <div class="signup-header-text">
                    <span>{{ formTitle }}</span>
                </div>
            </div>

            <signup-fields v-model="customer" @change="changed = true" ref="fields" :validation-scope="validationScope" :isDDSignup="inPathDD"></signup-fields>

            <!-- JOIN NOW Button -->
            <f9button :disabled="!changed" ref="submitButton" class="submit-button" @click="submit" :loading="submitting">
                JOIN NOW
            </f9button>
        </div>
        <!-- Success State -->
        <div class="signup-container" v-else :class="{ standalone: !inSlider }">
            <div class="signup-frontiermiles-logo success-state-logo">THANK YOU FOR SIGNING UP!</div>
            <div class="signup-p">
                You are now a member! You will receive an email with your membership information. You can also go to your 
                <span class="success-italic">FRONTIER</span> 
                profile to view your account, manage your preferences, and track your miles.
            </div>

            <!-- VIEW PROFILE Button -->
            <f9button ref="submitButton" class="submit-button view-profile-button" @click="viewProfile">
                VIEW PROFILE
            </f9button>

            <div class="signup-info-header green-cyan-gradient">
                <div class="ibe-text-like-h5">
                    <strong>ABOUT</strong>
                </div>
            </div>
            <div class="signup-info signup-images">
                <div class="signup-image">
                    <img :src="host + imageRelativePath + 'icon_mileformile.svg'" alt="">
                    <div class="signup-images-text-container">
                        <span class="signup-images-large-text">Mile for Miles</span>
                        <span class="signup-images-small-text">Earn 1 point for each mile flown. It's easy to earn & use your FRONTIER Miles.</span>
                        <a href="https://www.flyfrontier.com/frontiermiles/how-to-earn-miles" target="_blank" rel="noopener">LEARN MORE</a>
                    </div>
                </div>
                <div class="signup-image">
                    <img :src="host + imageRelativePath + 'icon_swipeearn.svg'" alt="">
                    <div class="signup-images-text-container">
                        <span class="signup-images-large-text">Swipe. Earn.</span>
                        <span class="signup-images-small-text">Unlock status, miles & family pooling with the FRONTIER Airlines World Mastercard.</span>
                        <a :href="this.barclaysFrontierMilesSignupLink" target="_blank" rel="noopener">LEARN MORE</a>
                    </div>
                </div>
                <div class="signup-image">
                    <img :src="host + imageRelativePath + 'icon_getstatus.svg'" alt="">
                    <div class="signup-images-text-container">
                        <span class="signup-images-large-text">Get Status</span>
                        <span class="signup-images-small-text">Elite Status and its exclusive benefits are within reach. </span>
                        <a href="https://www.flyfrontier.com/frontiermiles/elite-status-benefits" target="_blank" rel="noopener">LEARN MORE</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    
    .signup-container {
        color: @frontier-gray-dark;
        padding-bottom: 50px;
        width: 100%;

        .login-section {
            margin-bottom: 15px;

            .login-info-header{
                    color: @frontier-gray-dark;
                    font-size: 20px;
                    font-weight: 400;
                    display: flex;
                    margin-left:25px;

                    .Frontier{
                         font-weight: 700;
                         font-style: italic;
                    }
                    .my-img{
                        width: 25px;
                        height: 25px;
                        margin-top: 6px;
                    }
                    .sm {
                        font-size: 11px;
                        top: 9px;
                        padding-left: 2px;
                        font-weight: 700;
                    }
                }

            .login-form-section {
                padding: 17px 24px 0;

                .login-form-header {
                    font-size: 24px;
                    font-weight: 600;
                    line-height: 22.5px;
                    text-transform: uppercase;
                    color: @frontier-green;
                    margin-bottom: 10px;
                }
            }
        }

        .signup-password-container {
            display: flex;
            justify-content: flex-start;
        }
        .signup-password-requirements {
            display: flex;
            align-items: center;
            background-color: #e8e8e8;
            padding: 26px 22px 22px 33px;
            max-height: 113px;
            max-width: 348px;
            margin-top: 19px;
            margin-left: 16px;
            color: #6d6d6d;
            font-size: 12px;
            line-height: 16px;
        }

        &.standalone {
            padding: 20px;
        }

        .signup-frontiermiles-logo {
            img {
                width: 350px;
            }
        }
        
        .signup-p {
            margin-top: 5px;
        }
        
        

        .signup-info-header {
            font-size: 24px;
            margin-bottom: 6px;
            font-weight: 400;
            line-height: 45px;
            padding-left: 17px;
            background-color: @frontier-green;
            color: white;

            .signup-header-text {
                font-size: 28px;
                font-weight: 700;
            }
        }

        .view-profile-button {
            margin: 25px 0 55px 0;
        }

        .success-state-logo {
            font-style: normal;
        }

        .success-italic {
            font-style: italic;
        }

        .signup-images {
            display: flex;
            justify-content: space-around;
            background-color: @ibe-background--light-gray;
            border-style: none !important;

            .signup-image {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0 20px;
                width: 100%;

                .signup-images-text-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                }

                .signup-images-text-container span {
                    text-align: center;
                    margin-bottom: 3px;
                    width: 100%;
                }

                img {
                    width: 100px;
                    height: 100px;
                    min-width: 40px;
                    min-height: 40px;
                    margin-bottom: 10px;
                }

                .signup-images-large-text {
                    font-size: 16px;
                    font-weight: 600;
                    color: @frontier-gray-xxdark;
                }

                .signup-images-small-text {
                    font-size: 12px;
                    color: @ibe-text--light-bluegray;
                }

                a {
                    color: @frontier-green;
                    font-weight: 600;
                    font-size: 12px;
                }
            }
        }

        .signup-info {
            padding: 17px 24px 12px;
            border-style: solid;
            border-width: 1px;
            border-color: hsla(0, 0%, 43%, .25);
            box-sizing: border-box;
        }

        .signup-legend {
            text-align: right;
            margin-top: 10px;
            margin-bottom: 5px;
        }

        .text-small {
            font-size: 12px;
        }
    }

    @media @tablet {
        .signup-container {
            .signup-frontiermiles-logo {
                img {
                    width: 200px;
                }
            }

            .login-section {
                .login-info-header{
                    font-size: 14px;
                    margin-left:-25px;

                    .Frontier{
                         font-weight: 700;
                         font-style: italic;
                    }
                    .my-img{
                        width: 20px;
                        height: 20px;
                        margin-top: 7px;
                    }
                    .sm {
                        font-size: 11px;
                        top: 11px;
                        padding-left: 2px;
                        font-weight: 700;
                    }
                }

                .login-form-section {
                    padding: 17px 14px 0;
                
                    .login-form-header {
                        font-size: 16px;
                        line-height: 19px;
                        margin-bottom: 0;
                    }
                }
                
            }

            .signup-info-header {
                .signup-header-text {
                    font-size: 20px;
                }
            }

            .signup-p {
                font-size: 12px;
            }

            .view-profile-button {
                margin: 13px 2.5% 28px 2.5%;
            }

            .signup-images {
                flex-direction: column;

                .signup-image {
                    flex-direction: row;

                    img {
                        width: 40px;
                        height: 40px;
                    }

                    .signup-images-text-container {
                        flex-direction: column;
                        align-items: flex-start;
                        margin-left: 7px;
                        margin-bottom: 10px;

                        span {
                            text-align: start;
                            margin-bottom: 0;
                        }

                        .signup-images-large-text {
                            font-size: 12px;
                        }

                        .signup-images-small-text {
                            font-size: 10px;
                        }
                    }
                }
            }
        }
    }
</style>